export default function ContactSection() {
  return (
    <section id="contact" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              联系我们
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              如有电视剧全集收录建议、合作意向或问题反馈，欢迎联系萝卜影视团队
            </p>
          </div>

          <div className="max-w-[640px] mx-auto">
            <div className="bg-background-200/70 rounded-xl p-8 md:p-10 border border-background-300/30">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-foreground-100 text-sm font-medium mb-1">电子邮箱</h3>
                    <p className="text-foreground-400 text-xs">contact@luoboyingshi.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-accent-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-foreground-100 text-sm font-medium mb-1">微信公众号</h3>
                    <p className="text-foreground-400 text-xs">萝卜影视</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-chat-3-line text-primary-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-foreground-100 text-sm font-medium mb-1">剧集投稿</h3>
                    <p className="text-foreground-400 text-xs">submit@luoboyingshi.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shake-hands-line text-accent-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-foreground-100 text-sm font-medium mb-1">商务合作</h3>
                    <p className="text-foreground-400 text-xs">biz@luoboyingshi.com</p>
                  </div>
                </div>
              </div>

              <div className="p-4 rounded-lg bg-background-50 border border-background-300/30">
                <p className="text-foreground-500 text-xs leading-relaxed text-center">
                  我们会在收到信息后的 1-2 个工作日内回复。如需推荐电视剧全集收录，请注明剧名与来源平台。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}